var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotiNodata(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 138,
    viewBox: "0 0 121 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.933 43.3691L76.8058 10.4151H10.4698V127.585H109.933V43.3691ZM120.403 138H0V0H81.1409L120.403 39.0566V138Z",
    fill: "#D0D2D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3018 64.832H99.1004V75.9461H21.3018V64.832Z",
    fill: "#D0D2D5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5771 38.8994H112.067V49.0869H70.3896V10.1875H80.5771V38.8994Z",
    fill: "#D0D2D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3018 86.1328H99.1004V96.3207H21.3018V86.1328Z",
    fill: "#D0D2D5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3018 106.512H60.2011V117.626H21.3018V106.512Z",
    fill: "#D0D2D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiNodata);
export default __webpack_public_path__ + "static/media/notiNodata.eae3a2f1f8a1397b13f59c7487772659.svg";
export { ForwardRef as ReactComponent };